var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"action-panel"}},[_c('div',{staticClass:"message",class:{ 'underline': _vm.hasActionText }},[_vm._v(_vm._s(_vm.message))]),(_vm.hasActionText)?_c('button',{staticClass:"action",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('action-click')}}},[_vm._v(_vm._s(_vm.actionText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }